import React, {useState, useEffect} from "react";
import { useParams } from "react-router-dom";
import 'rsuite/dist/rsuite.min.css'; 
import { Nav } from 'rsuite'; 
import {useNavigate } from "react-router-dom";
import '../../Styles/Components/PublicForms/Navigation_Bar.css';
import iconAnalysis from '../../Images/iconAnalysis.png';
import iconPerson from '../../Images/iconPerson.png';
import iconSubscript from '../../Images/iconSubscription.png';
import iconSettings from '../../Images/iconSettings.png';
import iconLogOut from '../../Images/iconLogOut.png';
import isTokenExpired from "./isTokenExpired";
import { ScrollToTop } from "./ScrollToTop";


const Navigation_Bar = ()=>
{
    const{section, category, subscript,print, personID,subscriptID} = useParams();
    const Navigate = useNavigate();
    const[showSubScript, setShowSubScript] = useState(subscript == undefined ? false: true);
    const[showPrint, setShowPrint] = useState(print == "false" ? false: true);
    const[activeSection, setActiveSection] = useState(section);
    const[dashboardNav, setDashboardNav] = useState(section === "داشبورد" ? category :"analysis");
    const[personsNav, setPersonsNav] = useState(section ==="افراد"? category : "personsLst");
    const[subscriptNav, setSubscriptNav] = useState(section ==="اشتراک"? category : "subscriptLst");
    const[settingsNav, setSettingsNav] = useState(section === "تنظیمات"? category : "provinceLst");
    
    useEffect(() => {
        if (localStorage.getItem('token')) {
          const token = localStorage.getItem('token');
          if (isTokenExpired(token)) {
            localStorage.removeItem('token');
            Navigate("/login");
        } else {
            // setUser(JSON.parse(localStorage.getItem('user')));
          }
        } else {
            Navigate("/login");
        }
      }, []);

    return(

        <div className="verticalNav">
            <ScrollToTop />
            <div className="gapCol">
            </div>
            <div className="firstCol">
                <div className="firstColContain">
                    {/*  */}
                    <a id = "داشبورد" href="#" onClick={()=> {
                        setActiveSection("داشبورد");
                        setShowSubScript(false);
                        Navigate(`/dashboard/analysis/داشبورد/${dashboardNav}`);
                    
                    }}><img src={iconAnalysis}/>{activeSection == "داشبورد" ? <div className="displayCircle semiCircle"></div>: <div className="NonSemiCircle"></div>}</a>
                     {/*  */}
                    <a id = "افراد"  href="#" onClick={()=> {
                        setActiveSection("افراد");
                        setShowSubScript(false);
                        Navigate(`/persons/lstPersons/افراد/${personsNav}`);
                    }}><img src={iconPerson} />{activeSection == "افراد" ? <div className="displayCircle semiCircle"></div>: <div className="NonSemiCircle"></div>}</a>
                     {/*  */}
                    {  
                        showSubScript?
                            <a id = "سابقه اشتراک" href="#" onClick={()=> {
                                setActiveSection("اشتراک");
                                Navigate(`/dashboard/subscript/اشتراک/${subscriptNav}`);
                            
                            }}><img src={iconSubscript}/>{activeSection == "اشتراک" ? <div className="displayCircle semiCircle"></div>: <div className="NonSemiCircle"></div>}</a>
                            :
                            null
                    }
                    {/*  */}
                    <a id = "تنظیمات" href="#" onClick={()=> 
                        {
                            setActiveSection("تنظیمات");
                            setShowSubScript(false);
                            Navigate(`/settings/lstProvinces/تنظیمات/${settingsNav}`);


                        }}><img src={iconSettings}/>{activeSection == "تنظیمات" ? <div className="semiCircle displayCircle"></div>: <div className="NonSemiCircle"></div>}</a>
                    {/*  */}
                    {/* <a id = "خروج" href="#" onClick={()=> setActiveSection("خروج")}><img src={iconLogOut}/>{activeSection == "خروج" ? <div className="semiCircle displayCircle"></div>: <div className="NonSemiCircle"></div>}</a> */}
                </div>               
            </div>
            <div className="secondCol">
             
              <p>{activeSection}</p>

            {
                activeSection == "داشبورد" ?

                <Nav vertical activeKey= {dashboardNav} > 
                    <Nav.Item eventKey="analysis"  onSelect={
                        (e) => 
                            {
                             setDashboardNav(e);
                             Navigate(`/dashboard/analysis/${activeSection}/${e}`);
                            }
                        }> 
                        میزکار 

                    </Nav.Item> 
                    <Nav.Item eventKey="personsReport"  onSelect={(e) => 
                            {
                            setDashboardNav(e);
                            Navigate(`/dashboard/reports/${activeSection}/${e}`);

                            }
                        }> 
                        گزارش افراد 

                    </Nav.Item> 
                    
                
                </Nav> 
            :
            null

            }

            {
                activeSection == "افراد" ?

                <Nav vertical activeKey= {personsNav} > 
                    <Nav.Item eventKey="personsLst"  onSelect={(e) => {setPersonsNav(e)
                        Navigate(`/persons/lstPersons/${activeSection}/${e}`);

                    }}> 
                        مشترکین 

                    </Nav.Item>  
                    <Nav.Item eventKey="new"  onSelect={(e) => {setPersonsNav(e)
                        Navigate(`/persons/previewPersons/${activeSection}/${e}/${personID}`)
                    }}> 
                         جدید/ ویرایش
                    </Nav.Item> 
                    <Nav.Item eventKey="edit"  onSelect={(e) => setPersonsNav(e)}> 
                         

                    </Nav.Item> 
                
                </Nav> 
            :
            null

            }

            {
                activeSection == "اشتراک" ?

                <Nav vertical activeKey= {subscriptNav} > 
                    <Nav.Item eventKey="subScriptLst"  onSelect={(e) => {setSubscriptNav(e)
                        Navigate(`/subscripts/lstSubscripts/${activeSection}/${e}/${personID}/true/false`)

                    }}> 
                        سوابق اشتراک 

                    </Nav.Item>  
                    <Nav.Item eventKey="newSubScript"  onSelect={(e) => {setSubscriptNav(e)
                         Navigate(`/subscripts/previewSubscript/${activeSection}/${e}/${personID}/${subscriptID}/true/false`)
                        }}> 
                     جدید/ ویرایش
 

                    </Nav.Item> 
                    {
                        showPrint ?
                        <Nav.Item eventKey="printSubScript"  onSelect={(e) => {setSubscriptNav(e)
                            Navigate(`/subscripts/printSubscript/${activeSection}/${e}/${personID}/${subscriptID}/true/true`)
                            }}> 
                            چاپ
    

                        </Nav.Item> 
                        :
                        null
                    }
                   
                
                </Nav> 
            :
            null

            }

            {
                activeSection == "تنظیمات" ?

                <Nav vertical activeKey= {settingsNav} > 
                    <Nav.Item eventKey="provinceLst"  onSelect={(e) => 
                        {
                            setSettingsNav(e);
                            Navigate(`/settings/lstProvinces/${activeSection}/${e}`);

                        
                        }}> 
                        اسامی استان‌ها 

                    </Nav.Item> 
                    <Nav.Item eventKey="cityLst"  onSelect={(e) => 
                        {
                            setSettingsNav(e);
                            Navigate(`/settings/lstCities/${activeSection}/${e}`);


                        }}> 
                         اسامی شهرها 

                    </Nav.Item> 
                    <Nav.Item eventKey="newProvince"  onSelect={(e) => 
                        {
                            setSettingsNav(e);
                            Navigate(`/settings/previewProvinces/${activeSection}/${e}/0`)
                            
                        }}> 
                        استان جدید/ ویرایش 

                    </Nav.Item>  
                    <Nav.Item eventKey="newCity" onSelect={(e) => {
                        setSettingsNav(e);
                        Navigate(`/settings/previewCity/${activeSection}/${e}/0`)

                        }}> 
                        شهر جدید/ ویرایش

                    </Nav.Item> 
                    {/* <Nav.Item eventKey="changePass"  onSelect={(e) => setSettingsNav(e)}> 
                        تغییر رمز عبور 

                    </Nav.Item>  */}
                
                </Nav> 
            :
            null

            }
                 

            </div>

            
        </div>
    )
}

export default Navigation_Bar;
